"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";
import {initInScope,onFind} from "./elements-packages/init-modules-in-scope";
import {findIn,closest,removeClass, findAllIn, findAll, on, off, getAttribute, addClass, hasClass, setAttribute} from '@elements/dom-utils';
import {renderTemplate} from "./render-template";

const selectors = {
    base: '.js-nav',
    toggleOverlay: '.js-nav__toggle-overlay',
    showOverlay: '.js-nav__show-overlay',
    collapse: '.js-nav__collapse',
    overlay: '.js-nav__overlay',
    list: '.js-nav__list',
    listItem: '.js-nav__list-item',
    listToggle: '.js-nav__list-toggle',
    opacityToggle: '.js-nav__opacity-toggle'
};

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    onFind(selectors.base, function (baseElement) {
        let toggleOverlays = findAll(selectors.toggleOverlay);
        let showOverlays = findAll(selectors.showOverlay);

        showOverlays.forEach(function(toggleOverlay) {
            on('click', function (evt) {
                let targetId = toggleOverlay.getAttribute('data-nav-overlay-target');
                let overlayItem = findIn(targetId, baseElement);
                let renderTemplateItem = findIn('.js-nav__render-templates', baseElement);
                let renderTemplateSearch = findIn('.js-nav__render-search-templates', baseElement);

                console.log("render template search", renderTemplateSearch);

                if(renderTemplateItem) {
                    renderNavTemplate(renderTemplateItem);
                }

                addClass('show-overlay', overlayItem);
                setAttribute('aria-expanded', true, overlayItem);
                addClass('body--freezed', document.body);

            }, toggleOverlay);
        });

        toggleOverlays.forEach(function(toggleOverlay) {
            on('click', function(evt) {
                let targetId = toggleOverlay.getAttribute('data-nav-overlay-target');
                let overlayItem = findIn(targetId, baseElement);
                let renderTemplateItem = findIn('.js-nav__render-templates', overlayItem);

                if(renderTemplateItem) {
                    renderNavTemplate(renderTemplateItem);
                }

                if(hasClass('show-overlay', overlayItem)) {
                    hideItem(toggleOverlay);
                    hideOverlay(overlayItem);
                    removeClass('body--freezed', document.body);
                } else {
                    showItem(toggleOverlay);
                    showOverlay(overlayItem);
                    addClass('body--freezed', document.body);
                }

                function bodyClickHandler(evt) {
                    if (!closest('.main-navbar', evt.target)) {
                        evt.preventDefault();
                        hideItem(toggleOverlay);
                        hideOverlay(overlayItem);
                        removeClass('body--freezed', document.body);
                    }
                }

                function showOverlay(overlay) {
                    addClass('show-overlay', overlay);
                    setAttribute('aria-expanded', true, overlay);
                    if (!isMobile()) {
                        setTimeout(function() {
                            addBodyClickHandler(bodyClickHandler);
                        }, 300);
                    }
                }
                function hideOverlay(overlay) {
                    removeClass('show-overlay', overlay);
                    setAttribute('aria-expanded', false, overlay);
                    if (!isMobile()) {
                        removeBodyClickHandler(bodyClickHandler);
                    }
                }

            }, toggleOverlay);
        });

        onFind(selectors.list, function (list) {
            let listItems = findAllIn(selectors.listItem, list);
            let listToggle = findAllIn(selectors.listToggle, list);
            let opacityToggle = findAllIn(selectors.opacityToggle, list);

            listToggle.forEach(function(item) {
                on('click', function (evt) {
                    let element = evt.target;
                    evt.preventDefault();
                    let parentItem = closest(selectors.listItem, element);

                    if (hasClass('is-open', parentItem)) {
                        hideItem(parentItem);
                        opacityToggle.forEach(function(item) {
                            removeClass('mega-nav__item--opacity-toggle', item);
                        });
                    } else {
                        if (isMobile()) {
                            showItem(parentItem);
                        } else {
                            hideItems(listItems);
                            showItem(parentItem);
                            opacityToggle.forEach(function(item) {
                                addClass('mega-nav__item--opacity-toggle', item);
                            });
                            removeClass('mega-nav__item--opacity-toggle', element);
                        }
                    }
                }, item);
            });
        });
    });
}

function addBodyClickHandler(bodyClickHandler) {
    on('click', bodyClickHandler, document.body);
}
function removeBodyClickHandler(bodyClickHandler) {
    off('click', bodyClickHandler, document.body);
}
function hideItem(item) {
    removeClass('is-open', item);
    removeClass('is-open--only-desktop', item);
    setAttribute('aria-expanded', false, item);
}
function hideItems(items) {
    items.forEach(function(item) {
        removeClass('is-open', item);
        removeClass('is-open--only-desktop', item);
        setAttribute('aria-expanded', false, item);
    });

}
function showItem(item) {
    addClass('is-open', item);
    setAttribute('aria-expanded', true, item);
}

export function renderNavTemplate(renderItem) {
    let template = findIn('.js-nav-render-template__template',renderItem);
    let parent = renderItem.parentNode;

    if(template) {
        renderItem.innerHTML = template.innerHTML;
        removeClass('js-nav__render-templates',renderItem);
        removeClass('js-render-template',renderItem);

        template.remove();

        initInScope(renderItem);
    }
}